import { Injectable } from '@angular/core';

import { IBetStake, IStakeBetslip } from '@frontend/oxygen/shared-utils';

import { UserService } from '../../../core/services/user/user.service';
import { BetStake } from './bet-stake';

@Injectable({ providedIn: 'root' })
export class BetStakeService {
    constructor(private userService: UserService) {}

    construct(params: IStakeBetslip): BetStake | IBetStake {
        return new BetStake(params, this.userService);
    }

    parse(doc: IStakeBetslip, lines: number): BetStake | IBetStake {
        return this.construct({
            amount: doc.amount,
            perLine: doc.stakePerLine,
            max: doc.maxAllowed,
            min: doc.minAllowed,
            currency: this.userService.currency,
            lines,
        });
    }
}
